module.exports = __webpack_public_path__ + "media/images/icon-account-832b04393becf77d569549e1d7153e1e.svg";